/**
 * Sortable wrapper for JobCard using @dnd-kit.
 * See Phase 16.4: drag handle grip, blue drop zone indicator.
 */

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import JobCard from './JobCard';

export default function SortableJobCard({ job, onClockToggle, onPinToggle, activeClock }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: job.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 50 : 'auto',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <JobCard
        job={job}
        dragHandleProps={listeners}
        onClockToggle={onClockToggle}
        onPinToggle={onPinToggle}
        activeClock={activeClock}
      />
    </div>
  );
}
